import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, ReferenceField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { studentRequests } from "api/studentApi";
import { SectionTitle } from "features/SectionTitle";

const EducationSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Данни за обучение"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="education.specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Език на обучение">
            <ReferenceField
              source="education.instructionLanguageId"
              reference={administrationRequests.getInstructionLanguagesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Цикъл на обучение">
            <ReferenceField
              source="userInfo.cycleOfEducation"
              reference={erasmusRequests.getCycleOfEducationSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Учебна година">
            <ReferenceField
              source="userInfo.academicYearId"
              reference={studentRequests.getAcademicYearsSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Учебен план">
            <ReferenceField
              source="education.curriculumId"
              reference={studentRequests.getCurriculumsSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Изпращащ факултет">
            <TextField
              source="userInfo.sourceFaculty"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default EducationSection;
